import axios from 'axios';
import { isOnline } from '@/utils/connectivity';
import { cachePosSnapshot, getCachedPosSnapshot } from '@/utils/posOffline/db';
import {
  leerProductPins,
  productoEstaFijado,
  productPinOwner,
  toggleProductPin,
} from '@/utils/productPins';

export function unidadesVendidas(ranking, productoId) {
  if (!ranking || productoId == null) return 0;
  return Number(ranking[String(productoId)]) || 0;
}

export function ordenarProductosCatalogo(list, pins, ranking) {
  const pinIndex = new Map((pins || []).map((id, i) => [String(id), i]));
  return [...(Array.isArray(list) ? list : [])].sort((a, b) => {
    const idA = String(a && a.producto_id != null ? a.producto_id : '');
    const idB = String(b && b.producto_id != null ? b.producto_id : '');
    const pinA = pinIndex.has(idA) ? pinIndex.get(idA) : Infinity;
    const pinB = pinIndex.has(idB) ? pinIndex.get(idB) : Infinity;
    if (pinA !== pinB) return pinA - pinB;
    const uA = unidadesVendidas(ranking, idA);
    const uB = unidadesVendidas(ranking, idB);
    if (uA !== uB) return uB - uA;
    return String((a && a.producto_nombre) || '').localeCompare(String((b && b.producto_nombre) || ''), 'es');
  });
}

export async function fetchVentasRanking(usuario) {
  const key = `ventas_ranking:${usuario || 'anon'}`;
  try {
    if (usuario && isOnline()) {
      const { data } = await axios.get('/productos/ranking-ventas', { params: { usuario } });
      const ranking = (data && data.ranking && typeof data.ranking === 'object') ? data.ranking : {};
      await cachePosSnapshot(key, ranking);
      return ranking;
    }
  } catch {
    /* usar caché */
  }
  const cached = await getCachedPosSnapshot(key);
  return cached && typeof cached === 'object' ? cached : {};
}

export function catalogoOrdenMixin(vista) {
  return {
    data() {
      return {
        productPins: leerProductPins(vista, productPinOwner()),
        ventasRanking: {},
      };
    },
    methods: {
      ordenarCatalogo(list) {
        return ordenarProductosCatalogo(list, this.productPins, this.ventasRanking);
      },
      productoFijado(p) {
        return productoEstaFijado(this.productPins, p && p.producto_id);
      },
      toggleFijarProducto(p) {
        if (!p || p.producto_id == null) return;
        this.productPins = toggleProductPin(vista, p.producto_id, this.productPins, productPinOwner());
      },
      async cargarRankingVentas() {
        this.ventasRanking = await fetchVentasRanking(this.usuario);
      },
    },
  };
}
